import { CatalogItemListFilter } from '@common/model/catalog/item/list.filter';

export const toNumberArray = (value: CatalogItemListFilter['options']) => {
  if (Array.isArray(value)) {
    return value;
  } else if (value && typeof value === 'object') {
    if ('isAnyOf' in value && Array.isArray(value.isAnyOf)) {
      return value.isAnyOf;
    }
    if ('contains' in value && Array.isArray(value.contains)) {
      return value.contains;
    }
    if ('equals' in value && Array.isArray(value.equals)) {
      return value.equals;
    }
  }
  return [];
};
